export enum KINDS {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    DANGER = 'danger',
    GHOST = 'ghost'
}